import _getBuiltIn from "../internals/get-built-in";
var exports = {};
var getBuiltIn = _getBuiltIn;
exports = getBuiltIn("document", "documentElement");
export default exports;